import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from "../assets/images/logo/logoB.png";

const HomeHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll effect for better UX
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <header className={`bg-transparent relative z-40 transition-all duration-300 ${isScrolled ? 'pt-4 md:pt-6 lg:pt-8' : 'pt-4 sm:pt-6 md:pt-8 lg:pt-10'}`}>
        <div className="w-full max-w-[1792px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16">
          <div className="h-[50px] sm:h-[55px] md:h-[60px] flex items-center justify-between">
            {/* Left Panel - Logo (Responsive) */}
            <div className="flex items-center flex-shrink-0">
              <Link to="/" className="flex items-center" onClick={closeMenu}>
                <img
                  src={logo}
                  alt="Hair To Dye For Logo"
                  className="w-[180px] h-[28px] sm:w-[220px] sm:h-[35px] md:w-[250px] md:h-[39px] lg:w-[280px] lg:h-[44px] xl:w-[299px] xl:h-[47px] object-contain"
                />
              </Link>
            </div>

            {/* Desktop Navigation - Progressive display */}
            <nav className="hidden lg:flex flex-1 items-center justify-end">
              <div className="flex items-center gap-3 lg:gap-4 xl:gap-6 2xl:gap-8">
                {/* Regular menu items with responsive text */}
                <Link 
                  to="/about" 
                  className={`text-black hover:opacity-70 transition-opacity font-montserrat font-normal text-sm lg:text-sm xl:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                    isActive('/about') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-black' : ''
                  }`}
                >
                  ABOUT
                </Link>
                <Link 
                  to="/services" 
                  className={`text-black hover:opacity-70 transition-opacity font-montserrat font-normal text-sm lg:text-sm xl:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                    isActive('/services') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-black' : ''
                  }`}
                >
                  SERVICES
                </Link>
                <Link 
                  to="/artists" 
                  className={`text-black hover:opacity-70 transition-opacity font-montserrat font-normal text-sm lg:text-sm xl:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                    isActive('/artists') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-black' : ''
                  }`}
                >
                  ARTISTS
                </Link>
                
                {/* Gallery - Show on xl screens and up */}
                <Link 
                  to="/gallery" 
                  className={`hidden xl:block text-black hover:opacity-70 transition-opacity font-montserrat font-normal text-sm xl:text-base uppercase tracking-[0.15em] xl:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                    isActive('/gallery') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-black' : ''
                  }`}
                >
                  GALLERY
                </Link>
                
                {/* FAQ - Show on xl screens and up */}
                <Link 
                  to="/faq" 
                  className={`hidden xl:block text-black hover:opacity-70 transition-opacity font-montserrat font-normal text-sm xl:text-base uppercase tracking-[0.15em] xl:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                    isActive('/faq') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-black' : ''
                  }`}
                >
                  FAQ
                </Link>
                
                {/* CONTACT US - NOW VISIBLE ON XL SCREENS (not just 2xl) */}
                <Link 
                  to="/contact" 
                  className={`hidden xl:block text-black hover:opacity-70 transition-opacity font-montserrat font-normal text-sm xl:text-base uppercase tracking-[0.15em] xl:tracking-[0.2em] leading-[100%] whitespace-nowrap relative pb-2 ${
                    isActive('/contact') ? 'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:bg-black' : ''
                  }`}
                >
                  CONTACT US
                </Link>
                
                {/* CTA Button - Always visible on desktop */}
                 <a
  href="tel:+16109233530"
                  className="bg-[#C7A064] text-[#FAFAFA] px-4 lg:px-5 xl:px-6 2xl:px-7 py-2.5 lg:py-2.5 xl:py-3 rounded-[40px] font-montserrat font-semibold text-sm lg:text-sm xl:text-base uppercase tracking-[0.15em] lg:tracking-[0.2em] leading-[100%] whitespace-nowrap hover:opacity-90 hover:scale-105 transition-all min-w-[140px] lg:min-w-[160px] xl:min-w-[178px] min-h-[40px] lg:min-h-[45px] xl:min-h-[50px] flex items-center justify-center ml-2"
                >
                  CALL TO BOOK NOW
                </a>
              </div>
            </nav>

            {/* Mobile/Tablet Menu Button */}
            <div className="lg:hidden flex items-center">
              <button
                onClick={toggleMenu}
                className="text-black hover:opacity-70 transition-opacity p-2 relative w-10 h-10 flex items-center justify-center"
                aria-label="Toggle menu"
                aria-expanded={isMenuOpen}
              >
                <div className="flex flex-col justify-center items-center w-6 h-6 space-y-1.5">
                  <div className={`w-6 h-0.5 bg-black transition-all duration-300 transform origin-center ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></div>
                  <div className={`w-6 h-0.5 bg-black transition-all duration-300 ${isMenuOpen ? 'opacity-0 scale-0' : ''}`}></div>
                  <div className={`w-6 h-0.5 bg-black transition-all duration-300 transform origin-center ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile/Tablet Menu Overlay - Outside of header with highest z-index */}
      {isMenuOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="lg:hidden fixed inset-0 bg-black/50 backdrop-blur-sm"
            style={{ zIndex: 99998 }}
            onClick={closeMenu}
          />
          
          {/* Menu Panel */}
          <div 
            className="lg:hidden fixed inset-0 bg-black"
            style={{ zIndex: 99999 }}
          >
            <div className="flex flex-col h-full overflow-y-auto">
              {/* Mobile Menu Header with Logo and Close */}
              <div className="flex items-center justify-between px-4 sm:px-6 pt-4 sm:pt-6 md:pt-8">
                <Link to="/" onClick={closeMenu}>
                  <img
                    src={logo}
                    alt="Hair To Dye For Logo"
                    className="w-[180px] h-[28px] sm:w-[220px] sm:h-[35px] object-contain invert"
                  />
                </Link>
                <button
                  onClick={closeMenu}
                  className="text-white hover:opacity-70 transition-opacity p-3 relative w-12 h-12 flex items-center justify-center"
                  aria-label="Close menu"
                >
                  <div className="w-8 h-8 flex items-center justify-center">
                    <div className="w-6 h-0.5 bg-white rotate-45 absolute transition-transform hover:rotate-[135deg]"></div>
                    <div className="w-6 h-0.5 bg-white -rotate-45 absolute transition-transform hover:-rotate-[135deg]"></div>
                  </div>
                </button>
              </div>
              
              {/* Mobile Menu Navigation */}
              <nav className="flex-1 flex flex-col items-center justify-center px-6 sm:px-8 py-8 space-y-6 sm:space-y-7">
                <Link 
                  to="/" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-xl sm:text-2xl uppercase tracking-[0.2em] leading-[100%] ${
                    isActive('/') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  HOME
                </Link>
                <Link 
                  to="/about" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-xl sm:text-2xl uppercase tracking-[0.2em] leading-[100%] ${
                    isActive('/about') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  ABOUT
                </Link>
                <Link 
                  to="/services" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-xl sm:text-2xl uppercase tracking-[0.2em] leading-[100%] ${
                    isActive('/services') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  SERVICES
                </Link>
                <Link 
                  to="/artists" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-xl sm:text-2xl uppercase tracking-[0.2em] leading-[100%] ${
                    isActive('/artists') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  ARTISTS
                </Link>
                <Link 
                  to="/gallery" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-xl sm:text-2xl uppercase tracking-[0.2em] leading-[100%] ${
                    isActive('/gallery') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  GALLERY
                </Link>
                <Link 
                  to="/faq" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-xl sm:text-2xl uppercase tracking-[0.2em] leading-[100%] ${
                    isActive('/faq') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  FAQ
                </Link>
                <Link 
                  to="/contact" 
                  className={`text-white hover:text-[#C7A064] transition-colors font-montserrat font-normal text-xl sm:text-2xl uppercase tracking-[0.2em] leading-[100%] ${
                    isActive('/contact') ? 'text-[#C7A064]' : ''
                  }`}
                  onClick={closeMenu}
                >
                  CONTACT US
                </Link>
                
                {/* Mobile CTA Button */}
                 <a
  href="tel:+16109233530" 
                  className="bg-[#C7A064] text-[#FAFAFA] px-10 py-4 rounded-[40px] font-montserrat font-semibold text-lg uppercase tracking-[0.2em] leading-[100%] hover:opacity-90 hover:scale-105 transition-all mt-6 flex items-center justify-center min-w-[200px]"
                  onClick={closeMenu}
                >
                  CALL TO BOOK NOW
                </a>
              </nav>
              
              {/* Contact Info in Mobile Menu */}
              <div className="pb-8 text-center text-white/60 text-sm">
                <p className="mb-2">1 (610) 923-3530</p>
                <p>200 Northampton St, Easton, PA</p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HomeHeader;